"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotNull = void 0;
function isNotNull(x) {
    return !!x;
}
exports.isNotNull = isNotNull;
//# sourceMappingURL=isNotNull.js.map